import { render, staticRenderFns } from "./GenForm.vue?vue&type=template&id=09d6a608&scoped=true&"
import script from "./GenForm.vue?vue&type=script&lang=js&"
export * from "./GenForm.vue?vue&type=script&lang=js&"
import style0 from "./GenForm.vue?vue&type=style&index=0&id=09d6a608&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d6a608",
  null
  
)

export default component.exports